<template>
  <div></div>
</template>

<script>
export default {
  name: 'list',
  data () {
    return {}
  },
  components: {},
  methods: {},
  mounted () {}
}
</script>

<style lang="less" scoped>
</style>
